/**
 * Footer behaviors
 *
 * 1. Accordion: mobile-only collapsible toggle on link_list footer blocks.
 *    Toggles aria-expanded on the button; CSS handles the visual animation
 *    (expand/collapse + caret rotation) via [aria-expanded] selectors. CSS
 *    also disables interactivity on desktop via pointer-events, so we only
 *    act on the click when the viewport is mobile. Only one menu stays open
 *    at a time.
 *
 * 2. Display text: measures the SVG text element's natural bounding box
 *    (in SVG user-coordinate space) and sets the SVG viewBox to match.
 *    Because the SVG has width: 100% in CSS, the viewBox scales to fill
 *    the container — and the text inside scales with it. Net effect: the
 *    text always fills the container width, regardless of text length or
 *    viewport size. No font-size config needed.
 *
 *    The measurement runs after fonts finish loading (so we get the correct
 *    bbox for the chosen webfont, not the fallback). It also re-runs on
 *    Shopify section reload, so editing the text in the theme editor
 *    re-fits live.
 */

(function () {
  // -------------------------------------------------------------------------
  // 1. Accordion
  // -------------------------------------------------------------------------
  if ('matchMedia' in window) {
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var toggles = document.querySelectorAll('[data-footer-accordion-toggle]');

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function (event) {
        if (!mobileQuery.matches) return;
        var button = event.currentTarget;
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var willOpen = !expanded;

        button.setAttribute('aria-expanded', String(willOpen));

        // Khulte waqt baqi footer menus band kar do (ek waqt mein sirf ek)
        if (willOpen) {
          var scope = button.closest('.footer') || document;
          var others = scope.querySelectorAll('[data-footer-accordion-toggle]');
          for (var j = 0; j < others.length; j++) {
            if (others[j] !== button && others[j].getAttribute('aria-expanded') === 'true') {
              others[j].setAttribute('aria-expanded', 'false');
            }
          }
        }
      });
    }
  }

  // -------------------------------------------------------------------------
  // 2. Display text auto-fit
  // -------------------------------------------------------------------------
  function fitDisplayText() {
    var svgs = document.querySelectorAll('[data-footer-display-text]');
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      var text = svg.querySelector('text');
      if (!text) continue;

      // Reset to origin so getBBox returns natural untranslated bounds
      text.setAttribute('x', '0');
      text.setAttribute('y', '0');

      var bbox;
      try {
        bbox = text.getBBox();
      } catch (err) {
        // getBBox throws if the SVG isn't laid out yet (e.g., display:none)
        continue;
      }

      if (!bbox || bbox.width === 0 || bbox.height === 0) continue;

      // Shift the text so its bounding box starts at the viewBox origin,
      // then set viewBox to match those dimensions exactly. The SVG will
      // now scale the text to fill 100% of its container width.
      text.setAttribute('x', String(-bbox.x));
      text.setAttribute('y', String(-bbox.y));
      svg.setAttribute('viewBox', '0 0 ' + bbox.width + ' ' + bbox.height);
    }
  }

  // Wait for webfonts before measuring — fallback fonts have different
  // metrics and would give wrong bbox dimensions.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitDisplayText);
  } else if (document.readyState === 'complete') {
    fitDisplayText();
  } else {
    window.addEventListener('load', fitDisplayText);
  }

  // Re-fit when Shopify reloads the footer section in the theme editor
  // (so live edits to the display text show the correct fit immediately).
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-footer-display-text]')) {
      // Brief delay lets the new DOM settle and fonts apply
      setTimeout(fitDisplayText, 50);
    }
  });
})();